import { Outlet } from 'react-router-dom'
import { AppSidebar } from '@/components/layout/app-sidebar'
import EnhancedErrorBoundary from '@/components/error/error-boundary'

export function PortalLayout() {
  return (
    <AppSidebar>
      <EnhancedErrorBoundary>
        <Outlet />
      </EnhancedErrorBoundary>
    </AppSidebar>
  )
}
